import React from 'react'

const AuditIcon = (
  <>
    <path
      d="M18.3333 2.91675H8.33329C8.10288 2.91675 7.91663 3.103 7.91663 3.33341C7.91663 3.56383 8.10288 3.75008 8.33329 3.75008H18.3333C18.5637 3.75008 18.75 3.56383 18.75 3.33341C18.75 3.103 18.5637 2.91675 18.3333 2.91675Z"
      fill="#335262"
    />
    <path
      d="M18.3333 9.58325H8.33329C8.10288 9.58325 7.91663 9.7695 7.91663 9.99992C7.91663 10.2303 8.10288 10.4166 8.33329 10.4166H18.3333C18.5637 10.4166 18.75 10.2303 18.75 9.99992C18.75 9.7695 18.5637 9.58325 18.3333 9.58325Z"
      fill="#335262"
    />
    <path
      d="M18.3333 16.25H8.33329C8.10288 16.25 7.91663 16.4363 7.91663 16.6667C7.91663 16.8971 8.10288 17.0833 8.33329 17.0833H18.3333C18.5637 17.0833 18.75 16.8971 18.75 16.6667C18.75 16.4363 18.5637 16.25 18.3333 16.25Z"
      fill="#335262"
    />
    <path
      d="M5 1.25H1.66667C1.43625 1.25 1.25 1.43625 1.25 1.66667V5C1.25 5.23042 1.43625 5.41667 1.66667 5.41667H5C5.23042 5.41667 5.41667 5.23042 5.41667 5V1.66667C5.41667 1.43625 5.23042 1.25 5 1.25Z"
      fill="#1890FF"
    />
    <path
      d="M5 7.91675H1.66667C1.43625 7.91675 1.25 8.103 1.25 8.33341V11.6667C1.25 11.8972 1.43625 12.0834 1.66667 12.0834H5C5.23042 12.0834 5.41667 11.8972 5.41667 11.6667V8.33341C5.41667 8.103 5.23042 7.91675 5 7.91675Z"
      fill="#1890FF"
    />
    <path
      d="M5 14.5833H1.66667C1.43625 14.5833 1.25 14.7695 1.25 14.9999V18.3333C1.25 18.5637 1.43625 18.7499 1.66667 18.7499H5C5.23042 18.7499 5.41667 18.5637 5.41667 18.3333V14.9999C5.41667 14.7695 5.23042 14.5833 5 14.5833Z"
      fill="#1890FF"
    />
  </>
)

export default AuditIcon
